import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.tsx';
import './theme.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('找不到 #root 挂载点');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);


// 把构建号挂到 <html data-build> 上：线上排查时一眼能看出跑的是哪次构建，
// 同时保证每次发布的产物内容确实不同（内容哈希随之变化）。
document.documentElement.dataset['build'] = '1787219875';
